import { useMemo } from 'react';

import { endpoints } from '@/config/apiEndpoints';
import { useActiveOrganizationId } from '@/features/auth/session';
import { byName } from '@/features/brandHub/byName';
import { brandHubQueryKey } from '@/features/brandHub/queryKeys';
import { useLiveCollection, type LiveCollection } from '@/hooks/useLiveCollection';
import { collections } from '@/lib/firebase';
import { parseTemplate, type Template } from './types';

const TEMPLATE_LIMIT = 200;

/** Every HTML5 template of the organization. */
export function useTemplates(): LiveCollection<Template> {
  const organizationId = useActiveOrganizationId();

  const collection = useLiveCollection<Template>({
    path: collections.templates(organizationId ?? '_'),
    httpPath: endpoints.brandHub.templates(),
    queryKey: brandHubQueryKey('templates', organizationId),
    parse: parseTemplate,
    limit: TEMPLATE_LIMIT,
    enabled: Boolean(organizationId),
  });

  const data = useMemo(() => byName(collection.data, (template) => template.name), [collection.data]);
  return { ...collection, data };
}
